<template>
    <div>
        <Header />
        <PageTitle />
        <ServicesDetailsContent />
        <Footer />
    </div>
</template>

<script>
import Header from '../Layout/Header'
import PageTitle from '../ServicesDetails/PageTitle'
import ServicesDetailsContent from '../ServicesDetails/ServicesDetailsContent'
import Footer from '../Layout/Footer'

export default {
    name: 'ServicesDetailsPage',
    components: {
        Header,
        PageTitle,
        ServicesDetailsContent,
        Footer,
    }
}
</script>